export default __webpack_public_path__ + "static/media/user-5.d171d675.jpeg";